import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ButtonComponent, FileSizePipe, IconComponent, LoaderComponent } from '@ftr/foundation'
import { DropOverlayComponent } from './drop-overlay/drop-overlay.component'
import { FileDropDirective } from './file-drop/file-drop.directive'
import { FileSelectorModule } from './file-selector'
import { FileUploadItemComponent } from './file-upload-item.component'
import { FileUploadComponent } from './file-upload.component'
import { VirusScanningService } from './virus-scanning/virus-scanning.service'

@NgModule({
  imports: [
    ButtonComponent,
    CommonModule,
    DropOverlayComponent,
    FileDropDirective,
    FileSelectorModule,
    FileSizePipe,
    IconComponent,
    LoaderComponent,
  ],
  declarations: [FileUploadComponent, FileUploadItemComponent],
  exports: [FileUploadComponent],
  providers: [VirusScanningService],
})
export class FileUploadModule {}
